$shm_hitalama_map_page_arrows $mol_view
	Map_page $shm_hitalama_map_page
	visible true
	widget_arrows /$shm_hitalama_map_page_arrow_widgets
	widget_arrow_from_widget* $shm_hitalama_map_widget_float
	widget_arrow_to_widget* $shm_hitalama_map_widget_float
	Widget_arrow* $shm_hitalama_map_page_arrow_widgets
		from_widget <= widget_arrow_from_widget*
		to_widget <= widget_arrow_to_widget*
		kind <= widget_arrow_kind* \
